import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SurfLessons from "../pages/surf-lessons/page";
import KitesurfLessons from "../pages/kitesurf-lessons/page";
import EquipmentRental from "../pages/equipment-rental/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/surf-lessons",
    element: <SurfLessons />,
  },
  {
    path: "/kitesurf-lessons",
    element: <KitesurfLessons />,
  },
  {
    path: "/equipment-rental",
    element: <EquipmentRental />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
